'use client';

import { IconButton } from '@chakra-ui/react';
import { MdClose } from 'react-icons/md';

import { useI18n } from '@/__generated__/i18n.next';
import { Tooltip } from '@/components/__generated__/chakra-ui/tooltip';

import { useChatPaneSelector } from './ChatPaneContext';

export const ChatPaneCloseButton: React.FC = () => {
  const setChatState = useChatPaneSelector(([_, setValue]) => setValue);
  const t = useI18n();

  return (
    <Tooltip content={t.components.chatPane.close()}>
      <IconButton
        aria-label={t.components.chatPane.close()}
        size="sm"
        variant="ghost"
        onClick={() => {
          setChatState((draft) => {
            draft.isOpen = false;
          });
        }}
      >
        <MdClose />
      </IconButton>
    </Tooltip>
  );
};
